module.exports = __webpack_public_path__ + "ff7422a8a0484f862bda6d926e56536c.pdf";